import type { Batch50Seed } from './castBatch50DataV2.ts'

type NextBatch50Seed = Omit<Batch50Seed, 'sourceUrl' | 'relationships'> & {
  relationships: Omit<Batch50Seed['relationships'][number], 'sourceUrl'>[]
}

// October 1 profile expansion. People are linked from Journey90's catalog records;
// relationship appearance rows are retained separately from personal season credit.
export const nextBatch50Seeds: NextBatch50Seed[] =   [
    {
      "personId": "p-florian-sukaj",
      "name": "Florian Sukaj",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 1,
      "firstPartner": "Stacey's partner (supporting debut)",
      "billedFrom": "Unknown",
      "seasons": [
        {
          "show": "90 Day: The Last Resort",
          "season": 2
        }
      ],
      "relationships": [
        {
          "id": "ARC-9D1935CA31D5",
          "displayName": "Stacey & Florian",
          "firstShow": "90 Day: The Last Resort",
          "firstSeason": 2,
          "firstYear": 2024,
          "partners": [
            {
              "personId": "p-stacey-silva",
              "name": "Stacey Silva"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: The Last Resort",
              "season": 2
            }
          ]
        }
      ]
    },
    {
      "personId": "p-jesse-meester",
      "name": "Jesse Meester",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 1,
      "firstPartner": "Darcey",
      "billedFrom": "Netherlands",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 1
        },
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 2
        },
        {
          "show": "90 Day: The Single Life",
          "season": 2
        }
      ],
      "relationships": [
        {
          "id": "ARC-01ADFBFB9EED",
          "displayName": "Darcey & Jesse",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 1,
          "firstYear": 2017,
          "partners": [
            {
              "personId": "p-darcey-silva",
              "name": "Darcey Silva"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 1
            },
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 2
            }
          ]
        },
        {
          "id": "ARC-8AEAFAEF0FD6",
          "displayName": "Jesse & Jeniffer",
          "firstShow": "90 Day: The Single Life",
          "firstSeason": 2,
          "firstYear": 2021,
          "partners": [
            {
              "personId": "p-jeniffer-tarazona",
              "name": "Jeniffer Tarazona"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: The Single Life",
              "season": 2
            }
          ]
        }
      ]
    },
    {
      "personId": "p-tom-brooks",
      "name": "Tom Brooks",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 3,
      "firstPartner": "Darcey",
      "billedFrom": "United Kingdom",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 3
        },
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-6726515CA184",
          "displayName": "Darcey & Tom",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 3,
          "firstYear": 2019,
          "partners": [
            {
              "personId": "p-darcey-silva",
              "name": "Darcey Silva"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 3
            },
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-lisa-hamme",
      "name": "Lisa Hamme",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 4,
      "firstPartner": "Usman",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-6338A8038722",
          "displayName": "Lisa & Usman",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 4,
          "firstYear": 2020,
          "partners": [
            {
              "personId": "p-usman-umar",
              "name": "Usman Umar"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-cortney-reardanz",
      "name": "Cortney Reardanz",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 1,
      "firstPartner": "Antonio",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 1
        },
        {
          "show": "90 Day: Hunt for Love",
          "season": 1
        },
        {
          "show": "90 Day: The Single Life",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-6BE913DDDB72",
          "displayName": "Cortney & Antonio",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 1,
          "firstYear": 2017,
          "partners": [
            {
              "personId": "p-antonio-millon",
              "name": "Antonio Millón"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 1
            }
          ]
        },
        {
          "id": "ARC-F26BE50716DE",
          "displayName": "Cortney & Usman",
          "firstShow": "90 Day: Hunt for Love",
          "firstSeason": 1,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-usman-umar",
              "name": "Usman Umar"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: Hunt for Love",
              "season": 1
            }
          ]
        },
        {
          "id": "ARC-F701610A445B",
          "displayName": "Cortney & Colt",
          "firstShow": "90 Day: Hunt for Love",
          "firstSeason": 1,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-colt-johnson",
              "name": "Colt Johnson"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: Hunt for Love",
              "season": 1
            },
            {
              "show": "90 Day: The Single Life",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-jeniffer-tarazona",
      "name": "Jeniffer Tarazona",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 3,
      "firstPartner": "Timothy",
      "billedFrom": "Colombia",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 3
        },
        {
          "show": "90 Day: The Single Life",
          "season": 2
        },
        {
          "show": "90 Day: Hunt for Love",
          "season": 1
        }
      ],
      "relationships": [
        {
          "id": "ARC-5E9901D5F3A9",
          "displayName": "Tim & Jeniffer",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 3,
          "firstYear": 2019,
          "partners": [
            {
              "personId": "p-tim-malcolm",
              "name": "Tim Malcolm"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 3
            }
          ]
        },
        {
          "id": "ARC-8AEAFAEF0FD6",
          "displayName": "Jesse & Jeniffer",
          "firstShow": "90 Day: The Single Life",
          "firstSeason": 2,
          "firstYear": 2021,
          "partners": [
            {
              "personId": "p-jesse-meester",
              "name": "Jesse Meester"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: The Single Life",
              "season": 2
            }
          ]
        },
        {
          "id": "ARC-4A522D4B0E29",
          "displayName": "Jeniffer & Rob",
          "firstShow": "90 Day: Hunt for Love",
          "firstSeason": 1,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-rob-warne",
              "name": "Rob Warne"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: Hunt for Love",
              "season": 1
            }
          ]
        },
        {
          "id": "ARC-FD574218C9AC",
          "displayName": "Jeniffer & Cole",
          "firstShow": "90 Day: Hunt for Love",
          "firstSeason": 1,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-cole-90-day-hunt-for-love-s1",
              "name": "Cole"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: Hunt for Love",
              "season": 1
            }
          ]
        }
      ]
    },
    {
      "personId": "p-elise-benson",
      "name": "Elise Benson",
      "firstShow": "90 Day: Hunt for Love",
      "firstSeason": 1,
      "firstPartner": "single/dating arc",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day: Hunt for Love",
          "season": 1
        },
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 8
        }
      ],
      "relationships": [
        {
          "id": "ARC-5EA21F9F3FA8",
          "displayName": "Joshua & Elise",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 8,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-joshua-lawson",
              "name": "Joshua Lawson"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 8
            }
          ]
        },
        {
          "id": "ARC-6CB6773F8F74",
          "displayName": "Rob & Elise",
          "firstShow": "90 Day: Hunt for Love",
          "firstSeason": 1,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-rob-warne",
              "name": "Rob Warne"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: Hunt for Love",
              "season": 1
            }
          ]
        },
        {
          "id": "ARC-E02884CFF507",
          "displayName": "Carlo & Elise",
          "firstShow": "90 Day: Hunt for Love",
          "firstSeason": 1,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-carlo-90-day-hunt-for-love-s1",
              "name": "Carlo"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: Hunt for Love",
              "season": 1
            }
          ]
        }
      ]
    },
    {
      "personId": "p-carlo-90-day-hunt-for-love-s1",
      "name": "Carlo",
      "firstShow": "90 Day: Hunt for Love",
      "firstSeason": 1,
      "firstPartner": "single/dating arc",
      "billedFrom": "Unknown",
      "seasons": [
        {
          "show": "90 Day: Hunt for Love",
          "season": 1
        }
      ],
      "relationships": [
        {
          "id": "ARC-126865066DE2",
          "displayName": "Tiffany & Carlo",
          "firstShow": "90 Day: Hunt for Love",
          "firstSeason": 1,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-tiffany-franco",
              "name": "Tiffany Franco"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: Hunt for Love",
              "season": 1
            }
          ]
        },
        {
          "id": "ARC-E02884CFF507",
          "displayName": "Carlo & Elise",
          "firstShow": "90 Day: Hunt for Love",
          "firstSeason": 1,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-elise-benson",
              "name": "Elise Benson"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: Hunt for Love",
              "season": 1
            }
          ]
        }
      ]
    },
    {
      "personId": "p-colt-johnson",
      "name": "Colt Johnson",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 6,
      "firstPartner": "Larissa",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 6
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 4
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 5
        },
        {
          "show": "90 Day: The Single Life",
          "season": 1
        },
        {
          "show": "90 Day: Hunt for Love",
          "season": 1
        },
        {
          "show": "90 Day: The Single Life",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-DCDE4C29B7A4",
          "displayName": "Colt & Larissa",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 6,
          "firstYear": 2018,
          "partners": [
            {
              "personId": "p-larissa-dos-santos-lima",
              "name": "Larissa dos Santos Lima"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 6
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 4
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 5
            }
          ]
        },
        {
          "id": "ARC-41C27194D3BC",
          "displayName": "Colt & Vanessa",
          "firstShow": "90 Day: The Single Life",
          "firstSeason": 1,
          "firstYear": 2021,
          "partners": [
            {
              "personId": "p-vanessa-guerra-colt-arc",
              "name": "Vanessa Guerra"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: The Single Life",
              "season": 1
            }
          ]
        },
        {
          "id": "ARC-F701610A445B",
          "displayName": "Cortney & Colt",
          "firstShow": "90 Day: Hunt for Love",
          "firstSeason": 1,
          "firstYear": 2025,
          "partners": [
            {
              "personId": "p-cortney-reardanz",
              "name": "Cortney Reardanz"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: Hunt for Love",
              "season": 1
            },
            {
              "show": "90 Day: The Single Life",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-larissa-dos-santos-lima",
      "name": "Larissa dos Santos Lima",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 6,
      "firstPartner": "Colt",
      "billedFrom": "Brazil",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 6
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 4
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-DCDE4C29B7A4",
          "displayName": "Colt & Larissa",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 6,
          "firstYear": 2018,
          "partners": [
            {
              "personId": "p-colt-johnson",
              "name": "Colt Johnson"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 6
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 4
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-anfisa-arkhipchenko",
      "name": "Anfisa Arkhipchenko",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 4,
      "firstPartner": "Jorge",
      "billedFrom": "Russia",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 4
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 2
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 3
        }
      ],
      "relationships": [
        {
          "id": "ARC-E8D5CECFB0CC",
          "displayName": "Jorge & Anfisa",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 4,
          "firstYear": 2016,
          "partners": [
            {
              "personId": "p-jorge-nava",
              "name": "Jorge Nava"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 4
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 2
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 3
            }
          ]
        }
      ]
    },
    {
      "personId": "p-jorge-nava",
      "name": "Jorge Nava",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 4,
      "firstPartner": "Anfisa",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 4
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 2
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 3
        }
      ],
      "relationships": [
        {
          "id": "ARC-E8D5CECFB0CC",
          "displayName": "Jorge & Anfisa",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 4,
          "firstYear": 2016,
          "partners": [
            {
              "personId": "p-anfisa-arkhipchenko",
              "name": "Anfisa Arkhipchenko"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 4
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 2
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 3
            }
          ]
        }
      ]
    },
    {
      "personId": "p-nicole-nafziger",
      "name": "Nicole Nafziger",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 4,
      "firstPartner": "Azan",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 4
        },
        {
          "show": "90 Day Fiancé",
          "season": 5
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 3
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-C6B6EEBC6790",
          "displayName": "Nicole & Azan",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 4,
          "firstYear": 2016,
          "partners": [
            {
              "personId": "p-azan-tefou",
              "name": "Azan Tefou"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 4
            },
            {
              "show": "90 Day Fiancé",
              "season": 5
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 3
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-azan-tefou",
      "name": "Azan Tefou",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 4,
      "firstPartner": "Nicole",
      "billedFrom": "Morocco",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 4
        },
        {
          "show": "90 Day Fiancé",
          "season": 5
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 3
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-C6B6EEBC6790",
          "displayName": "Nicole & Azan",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 4,
          "firstYear": 2016,
          "partners": [
            {
              "personId": "p-nicole-nafziger",
              "name": "Nicole Nafziger"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 4
            },
            {
              "show": "90 Day Fiancé",
              "season": 5
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 3
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-danielle-mullins",
      "name": "Danielle Mullins",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 2,
      "firstPartner": "Mohamed",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 2
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 1
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 2
        },
        {
          "show": "90 Day: The Single Life",
          "season": 1
        }
      ],
      "relationships": [
        {
          "id": "ARC-554F65E5B213",
          "displayName": "Danielle & Mohamed",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 2,
          "firstYear": 2014,
          "partners": [
            {
              "personId": "p-mohamed-jbali",
              "name": "Mohamed Jbali"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 2
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 1
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 2
            }
          ]
        }
      ]
    },
    {
      "personId": "p-mohamed-jbali",
      "name": "Mohamed Jbali",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 2,
      "firstPartner": "Danielle",
      "billedFrom": "Tunisia",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 2
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 1
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 2
        }
      ],
      "relationships": [
        {
          "id": "ARC-554F65E5B213",
          "displayName": "Danielle & Mohamed",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 2,
          "firstYear": 2014,
          "partners": [
            {
              "personId": "p-danielle-mullins",
              "name": "Danielle Mullins"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 2
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 1
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 2
            }
          ]
        }
      ]
    },
    {
      "personId": "p-molly-hopkins",
      "name": "Molly Hopkins",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 5,
      "firstPartner": "Luis",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 5
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 3
        },
        {
          "show": "90 Day: The Single Life",
          "season": 1
        },
        {
          "show": "90 Day: The Last Resort",
          "season": 1
        }
      ],
      "relationships": [
        {
          "id": "ARC-BDE0A0FD1507",
          "displayName": "Molly & Luis",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 5,
          "firstYear": 2017,
          "partners": [
            {
              "personId": "p-luis-mendez",
              "name": "Luis Mendez"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 5
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 3
            }
          ]
        },
        {
          "id": "ARC-360783C5EC56",
          "displayName": "Molly & Kelly",
          "firstShow": "90 Day: The Single Life",
          "firstSeason": 1,
          "firstYear": 2021,
          "partners": [
            {
              "personId": "p-kelly-brown",
              "name": "Kelly Brown"
            }
          ],
          "appearances": [
            {
              "show": "90 Day: The Last Resort",
              "season": 1
            },
            {
              "show": "90 Day: The Single Life",
              "season": 1
            }
          ]
        }
      ]
    },
    {
      "personId": "p-luis-mendez",
      "name": "Luis Mendez",
      "firstShow": "90 Day Fiancé",
      "firstSeason": 5,
      "firstPartner": "Molly",
      "billedFrom": "Dominican Republic",
      "seasons": [
        {
          "show": "90 Day Fiancé",
          "season": 5
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 3
        }
      ],
      "relationships": [
        {
          "id": "ARC-BDE0A0FD1507",
          "displayName": "Molly & Luis",
          "firstShow": "90 Day Fiancé",
          "firstSeason": 5,
          "firstYear": 2017,
          "partners": [
            {
              "personId": "p-molly-hopkins",
              "name": "Molly Hopkins"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé",
              "season": 5
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 3
            }
          ]
        }
      ]
    },
    {
      "personId": "p-paul-staehle",
      "name": "Paul Staehle",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 1,
      "firstPartner": "Karine",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 1
        },
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 2
        },
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 1
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-0B268311534B",
          "displayName": "Paul & Karine",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 1,
          "firstYear": 2017,
          "partners": [
            {
              "personId": "p-karine-martins",
              "name": "Karine Martins"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 1
            },
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 2
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 5
            },
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 1
            }
          ]
        }
      ]
    },
    {
      "personId": "p-karine-martins",
      "name": "Karine Martins",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 1,
      "firstPartner": "Paul",
      "billedFrom": "Brazil",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 1
        },
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 2
        },
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 1
        },
        {
          "show": "90 Day Fiancé: Happily Ever After?",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-0B268311534B",
          "displayName": "Paul & Karine",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 1,
          "firstYear": 2017,
          "partners": [
            {
              "personId": "p-paul-staehle",
              "name": "Paul Staehle"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 1
            },
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 2
            },
            {
              "show": "90 Day Fiancé: Happily Ever After?",
              "season": 5
            },
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 1
            }
          ]
        }
      ]
    },
    {
      "personId": "p-amanda-wilhelm",
      "name": "Amanda Wilhelm",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Razvan",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-AE03C8C74A4C",
          "displayName": "Amanda & Razvan",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-razvan-ciocoi",
              "name": "Răzvan Ciocoi"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-razvan-ciocoi",
      "name": "Răzvan Ciocoi",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Amanda",
      "billedFrom": "Romania",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-AE03C8C74A4C",
          "displayName": "Amanda & Razvan",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-amanda-wilhelm",
              "name": "Amanda Wilhelm"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-brandan-denuccio",
      "name": "Brandan DeNuccio",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 5,
      "firstPartner": "Mary",
      "billedFrom": "Philippines",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-039D29C0E979",
          "displayName": "Brandan & Mary",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 5,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-mary-demasu-ay",
              "name": "Mary Demasu-ay"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-mary-demasu-ay",
      "name": "Mary Demasu-ay",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 5,
      "firstPartner": "Brandan",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-039D29C0E979",
          "displayName": "Brandan & Mary",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 5,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-brandan-denuccio",
              "name": "Brandan DeNuccio"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-statler-riley",
      "name": "Statler Riley",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Dempsey",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        },
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-07E406982111",
          "displayName": "Statler & Dempsey",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-dempsey-wilkinson",
              "name": "Dempsey Wilkinson"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            },
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-dempsey-wilkinson",
      "name": "Dempsey Wilkinson",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Statler",
      "billedFrom": "United Kingdom",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        },
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-07E406982111",
          "displayName": "Statler & Dempsey",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-statler-riley",
              "name": "Statler Riley"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            },
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-david-dangerfield",
      "name": "David Dangerfield",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Sheila",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-071F654691BF",
          "displayName": "David & Sheila",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-sheila-mangubat",
              "name": "Sheila Mangubat"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-sheila-mangubat",
      "name": "Sheila Mangubat",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "David",
      "billedFrom": "Philippines",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-071F654691BF",
          "displayName": "David & Sheila",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-david-dangerfield",
              "name": "David Dangerfield"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-christian-allgood",
      "name": "Christian Allgood",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Cleo",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-00BDA2F67CCA",
          "displayName": "Christian & Cleo",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-cleo-corraine",
              "name": "Cleo Corraine"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-cleo-corraine",
      "name": "Cleo Corraine",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Christian",
      "billedFrom": "United Kingdom",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-00BDA2F67CCA",
          "displayName": "Christian & Cleo",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-christian-allgood",
              "name": "Christian Allgood"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-riley-diego",
      "name": "Riley Diego",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Violet",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-244E720397F1",
          "displayName": "Riley & Violet",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-violet-tuyet",
              "name": "Violet Tuyet"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-violet-tuyet",
      "name": "Violet Tuyet",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Riley",
      "billedFrom": "Vietnam",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-244E720397F1",
          "displayName": "Riley & Violet",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-riley-diego",
              "name": "Riley Diego"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-meisha-johnson",
      "name": "Meisha Johnson",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Nicola",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-AAD78628BFF6",
          "displayName": "Meisha & Nicola",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-nicola-kanaan",
              "name": "Nicola Kanaan"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-nicola-kanaan",
      "name": "Nicola Kanaan",
      "firstShow": "90 Day Fiancé: Before the 90 Days",
      "firstSeason": 6,
      "firstPartner": "Meisha",
      "billedFrom": "Israel",
      "seasons": [
        {
          "show": "90 Day Fiancé: Before the 90 Days",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-AAD78628BFF6",
          "displayName": "Meisha & Nicola",
          "firstShow": "90 Day Fiancé: Before the 90 Days",
          "firstSeason": 6,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-meisha-johnson",
              "name": "Meisha Johnson"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: Before the 90 Days",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-holly-weeks",
      "name": "Holly Weeks",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 5,
      "firstPartner": "Wayne",
      "billedFrom": "South Africa",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-DB73BE796A45",
          "displayName": "Holly & Wayne",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 5,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-wayne-cornish",
              "name": "Wayne Cornish"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-wayne-cornish",
      "name": "Wayne Cornish",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 5,
      "firstPartner": "Holly",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-DB73BE796A45",
          "displayName": "Holly & Wayne",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 5,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-holly-weeks",
              "name": "Holly Weeks"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-kimberly-rochelle",
      "name": "Kimberly Rochelle",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 5,
      "firstPartner": "Tejaswi (TJ)",
      "billedFrom": "India",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-66D766D95CC9",
          "displayName": "Kimberly & TJ",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 5,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-tejaswi-goswami",
              "name": "Tejaswi Goswami"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-tejaswi-goswami",
      "name": "Tejaswi Goswami",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 5,
      "firstPartner": "Kimberly",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-66D766D95CC9",
          "displayName": "Kimberly & TJ",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 5,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-kimberly-rochelle",
              "name": "Kimberly Rochelle"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-daniele-gates",
      "name": "Daniele Gates",
      "firstShow": "90 Day Fiancé: Love in Paradise",
      "firstSeason": 2,
      "firstPartner": "Yohan",
      "billedFrom": "Dominican Republic",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 4
        },
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-8818616DC280",
          "displayName": "Daniele & Yohan",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 4,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-yohan-geronimo",
              "name": "Yohan Geronimo"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 4
            },
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-yohan-geronimo",
      "name": "Yohan Geronimo",
      "firstShow": "90 Day Fiancé: Love in Paradise",
      "firstSeason": 2,
      "firstPartner": "Daniele",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 4
        },
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-8818616DC280",
          "displayName": "Daniele & Yohan",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 4,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-daniele-gates",
              "name": "Daniele Gates"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 4
            },
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-gabe-paboga",
      "name": "Gabe Paboga",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 4,
      "firstPartner": "Isabel",
      "billedFrom": "Colombia",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-BE2E1E85CB20",
          "displayName": "Gabriel & Isabel",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 4,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-isabel-posada",
              "name": "Isabel Posada"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-isabel-posada",
      "name": "Isabel Posada",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 4,
      "firstPartner": "Gabe",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-BE2E1E85CB20",
          "displayName": "Gabriel & Isabel",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 4,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-gabe-paboga",
              "name": "Gabe Paboga"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-kris-foster",
      "name": "Kris Foster",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 4,
      "firstPartner": "Jeymi",
      "billedFrom": "Colombia",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-348C031DEBD8",
          "displayName": "Kris & Jeymi",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 4,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-jeymi-noguera",
              "name": "Jeymi Noguera"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-jeymi-noguera",
      "name": "Jeymi Noguera",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 4,
      "firstPartner": "Kris",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-348C031DEBD8",
          "displayName": "Kris & Jeymi",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 4,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-kris-foster",
              "name": "Kris Foster"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-jen-boecher",
      "name": "Jen Boecher",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 4,
      "firstPartner": "Rishi",
      "billedFrom": "India",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-844CAEADBF92",
          "displayName": "Jen & Rishi",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 4,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-rishi-singh",
              "name": "Rishi Singh"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-rishi-singh",
      "name": "Rishi Singh",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 4,
      "firstPartner": "Jen",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 4
        }
      ],
      "relationships": [
        {
          "id": "ARC-844CAEADBF92",
          "displayName": "Jen & Rishi",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 4,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-jen-boecher",
              "name": "Jen Boecher"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 4
            }
          ]
        }
      ]
    },
    {
      "personId": "p-julio-moya",
      "name": "Julio Moya",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 5,
      "firstPartner": "Kirsten",
      "billedFrom": "Netherlands",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-0A887CB87107",
          "displayName": "Julio & Kirsten",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 5,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-kirsten-schoemaker",
              "name": "Kirsten Schoemaker"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-kirsten-schoemaker",
      "name": "Kirsten Schoemaker",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 5,
      "firstPartner": "Julio",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 5
        }
      ],
      "relationships": [
        {
          "id": "ARC-0A887CB87107",
          "displayName": "Julio & Kirsten",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 5,
          "firstYear": 2023,
          "partners": [
            {
              "personId": "p-julio-moya",
              "name": "Julio Moya"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 5
            }
          ]
        }
      ]
    },
    {
      "personId": "p-james-solis",
      "name": "James Solis",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 6,
      "firstPartner": "Meitalia",
      "billedFrom": "Indonesia",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-487BEFD0035B",
          "displayName": "James & Tata",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 6,
          "firstYear": 2024,
          "partners": [
            {
              "personId": "p-meitalia-solis",
              "name": "Meitalia Solis"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 6
            }
          ]
        }
      ]
    },
    {
      "personId": "p-meitalia-solis",
      "name": "Meitalia Solis",
      "firstShow": "90 Day Fiancé: The Other Way",
      "firstSeason": 6,
      "firstPartner": "James",
      "billedFrom": "United States",
      "seasons": [
        {
          "show": "90 Day Fiancé: The Other Way",
          "season": 6
        }
      ],
      "relationships": [
        {
          "id": "ARC-487BEFD0035B",
          "displayName": "James & Tata",
          "firstShow": "90 Day Fiancé: The Other Way",
          "firstSeason": 6,
          "firstYear": 2024,
          "partners": [
            {
              "personId": "p-james-solis",
              "name": "James Solis"
            }
          ],
          "appearances": [
            {
              "show": "90 Day Fiancé: The Other Way",
              "season": 6
            }
          ]
        }
      ]
    }
  ]
